import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { data, appType, trialService } from "@/data/data";
import { flatten } from "lodash";

const sleep = (time) => new Promise((res) => setTimeout(() => res()), time);

// 즐겨찾기
export const bookmarkStore = atomWithStorage("caihong_study_bookmark", []);
// 다음학습 OR 이어하기
/*
  bookKey: null,
  page: -1,
*/
export const continuekStore = atomWithStorage("caihong_study_continue", null);
// 완료된 학습
export const studyCompleteStore = atomWithStorage("caihong_study_complete", []);
// // 해금된 학습
// const defaultUnLockKeys =
//   window.location.href.indexOf("fro9.net") > -1
//     ? ["c1-01", "c2-01", "c3-01"]
//     : ["c1-01", "c2-01", "c3-01", "c4-01", "c5-01", "c6-01", "c7-01"];

const allUnLock = [
  "c1-01",
  "c1-02",
  "c1-03",
  "c1-04",
  "c1-05",
  "c1-06",
  "c1-07",
  "c1-08",

  "c2-01",
  "c2-02",
  "c2-03",
  "c2-04",
  "c2-05",
  "c2-06",
  "c2-07",
  "c2-08",

  "c3-01",
  "c3-02",
  "c3-03",
  "c3-04",
  "c3-05",
  "c3-06",
  "c3-07",
  "c3-08",

  "c4-01",
  "c4-02",
  "c4-03",
  "c4-04",
  "c4-05",
  "c4-06",
  "c4-07",
  "c4-08",
  "c4-09",
  "c4-10",
  "c4-11",
  "c4-12",

  "c5-01",
  "c5-02",
  "c5-03",
  "c5-04",
  "c5-05",
  "c5-06",
  "c5-07",
  "c5-08",
  "c5-09",
  "c5-10",
  "c5-11",
  "c5-12",

  "c6-01",
  "c6-02",
  "c6-03",
  "c6-04",
  "c6-05",
  "c6-06",
  "c6-07",
  "c6-08",
  "c6-09",
  "c6-10",
  "c6-11",
  "c6-12",

  "c7-01",
  "c7-02",
  "c7-03",
  "c7-04",
  "c7-05",
  "c7-06",
  "c7-07",
  "c7-08",
  "c7-09",
  "c7-10",
  "c7-11",
  "c7-12",

  "c8-01",
  "c8-02",
  "c8-03",
  "c8-04",
  "c8-05",
];
const defaultUnLock = [
  "c1-01",
  "c2-01",
  "c3-01",
  "c4-01",
  "c5-01",
  "c6-01",
  "c7-01",
  "c8-01",
];
const trialServiceUnLock = ["c1-01", "c2-01", "c3-01"];
// app타입에 따라 기본 unlock 책이 다르게 셋팅된다.
const initialUnLock =
  trialService === true
    ? trialServiceUnLock
    : appType === "external"
    ? allUnLock
    : defaultUnLock;

export const unlockBookStore = atomWithStorage(
  "caihong_study_unlock",
  initialUnLock
);

export const appActiveCount = atomWithStorage("caihong_study_active_count", 0);

export const appData = atom(async (get) => {
  for (const sa of data.studybooks) {
    const categoryKey = sa.categoryKey;
    const category = sa.category;
    const color = sa.color;

    sa.books.forEach((a) => {
      a.category = category;
      a.categoryKey = categoryKey;
      a.color = color;
    });
  }
  await sleep(500);

  window.__flatKeys = flatten(
    data.studybooks.map((book) => {
      return book.books.map((d) => d.key);
    })
  );
  return data;
});

export const continueData = atom(null);
export const bgmState = atomWithStorage("caihong_study_bgm", 0.5);
